import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { getTenantId } from "@/store/helper";
import { IGridOption } from "../models/shared/gridOption";
import { FileDownloadModel } from "../models/fileUpload/fileDownloadDTO";
import axios from "axios";
let FilesUploadModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e;
    let FilesUploadModule = class FilesUploadModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "FileUpload";
            this.files = [];
            this.searchedFiles = [];
            this.totalCount = 0;
            this.fileURL = "";
        }
        async GetFiles(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetFiles(data.files);
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        async GetUploadSASUrl(fileName) {
            var url = `${getTenantId()}/${this.apiNode}/uploadSASUrl`;
            var fileDownload = new FileDownloadModel();
            fileDownload.fileMappedKey = fileName;
            let { data } = await service.post(url, fileDownload);
            if (data) {
                this.SasUrl(data);
                return data;
            }
        }
        async uploadFile(uploadedFile) {
            const response = await axios.put(this.fileURL, uploadedFile, {
                headers: {
                    "x-ms-blob-type": "BlockBlob",
                    "Content-Type": uploadedFile.type,
                },
            });
            return response;
        }
        async saveFile(uploadedFile) {
            let formData = new FormData();
            formData.append("file", uploadedFile);
            var url = `${getTenantId()}/${this.apiNode}/add`;
            let { data } = await service.post(url, formData);
            if (data) {
                return data;
            }
        }
        SasUrl(data) {
            this.fileURL = data;
        }
        async GetSearchFiles(searchCharacters) {
            var url = `${getTenantId()}/${this.apiNode}/search?searchCharacters=${searchCharacters}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetSearchedFiles(data.searchedFiles);
                return data;
            }
        }
        async DownLoadFile(mappedKey) {
            var url = `${getTenantId()}/${this.apiNode}/download-file`;
            var fileDownload = new FileDownloadModel();
            fileDownload.fileMappedKey = mappedKey;
            let { data } = await service.post(url, fileDownload);
            if (data) {
                this.SetUrl(data);
                return data;
            }
        }
        async DeleteFile(fileId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/` + fileId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        SetUrl(data) {
            var a = document.createElement("a");
            a.href = data.fileURL;
            a.click();
        }
        SetTotalCount(count) {
            this.totalCount = count;
        }
        SetFiles(files) {
            this.files = files;
        }
        SetSearchedFiles(searchedFiles) {
            this.searchedFiles = searchedFiles;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IGridOption !== "undefined" && IGridOption) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], FilesUploadModule.prototype, "GetFiles", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], FilesUploadModule.prototype, "GetUploadSASUrl", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], FilesUploadModule.prototype, "uploadFile", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], FilesUploadModule.prototype, "saveFile", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FilesUploadModule.prototype, "SasUrl", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], FilesUploadModule.prototype, "GetSearchFiles", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], FilesUploadModule.prototype, "DownLoadFile", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], FilesUploadModule.prototype, "DeleteFile", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FilesUploadModule.prototype, "SetUrl", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], FilesUploadModule.prototype, "SetTotalCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FilesUploadModule.prototype, "SetFiles", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FilesUploadModule.prototype, "SetSearchedFiles", null);
    FilesUploadModule = __decorate([
        Module({ dynamic: true, store: store, name: "fileUpload", namespaced: true })
    ], FilesUploadModule);
    return FilesUploadModule;
})();
export const FileUploadModule = getModule(FilesUploadModule);
